module.exports = __webpack_public_path__ + "img/8_new.0dd16ec8.png";